import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

import { PublicPageTemplate } from 'ui/templates';

import Button from 'ui/_components/Button/Button';

import s from './about-us.page.module.css';
import { useAboutUs } from './about-us.page.model';

export default function AboutUsPage() {
  const { aboutUsData, getAboutUsData, isLoading } = useAboutUs();

  useEffect(() => {
    getAboutUsData();
  }, []);

  if (!aboutUsData || isLoading) return null;
  return (
    <PublicPageTemplate>
      <div className={s.pageWrapper}>
        <section className={s.headerBlock}>
          <div className={s.blockContainer}>
            <h1 className={s.title}>{aboutUsData.title}</h1>
          </div>
        </section>
        <section className={s.contentWrapper}>
          <div className={s.content}>
            <div
              className={s.text}
              dangerouslySetInnerHTML={(() => ({
                __html: aboutUsData.content,
              }))()}
            />

            <div className={s.bottomText}>
              <p>Pawzr. Because pets are our world, too.</p>
            </div>
            <div className={s.bottomLine} />
          </div>
        </section>
        <div className={s.buttonRowWrapper}>
          <div className={s.buttonRow}>
            <Link to={'/sign-up-pet-owner'}>
              <Button className={s.button} size="medium">
                Create a profile
              </Button>
            </Link>
            <Link to={'/sign-up-provider'}>
              <Button className={s.button} size="medium" isOpacity>
                List your Business
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </PublicPageTemplate>
  );
}
